import { render, staticRenderFns } from "./BrowserSupport.vue?vue&type=template&id=81d6e1fe&"
import script from "./BrowserSupport.vue?vue&type=script&lang=ts&"
export * from "./BrowserSupport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemIcon } from 'vuetify/lib'
import { VListItemSubtitle } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
installComponents(component, {VContainer,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemSubtitle,VListItemTitle})
